import React, {useEffect, useRef, useState} from 'react';
import {Col, Container, Row} from 'react-bootstrap';

import {service as ActivityFeedFilterService} from "../../../Services/ActivityFeedFilterService";
import {service as ActivityTypeService} from "../../../Services/ActivityTypeService";

import { useMakePageRequest } from "../../../Hooks/RequestHooks";

import {useClassNames} from "../../../Hooks/StyleHooks";

import {ActivityFeed} from "../../Common/ActivityFeed/ActivityFeed";
import {ActivityTypeFilter} from '../../Common/ActivityFeed/ActivityTypeFilter';
import {
    ActivityFeedSubscriptionDropDown
} from '../../Common/ActivityFeed/ActivityFeedSubscriptionDropDown';
import {service as ContextNodeActivityService} from "../../../Services/ContextNodeActivityService";
import {useSelector} from "react-redux";
import {service as ContextNodeService} from "../../../Services/ContextNodeService";
import {selectDeepestBreadcrumb} from "../../../Redux/Selectors/contextSelectors";

export const ContextNodeActivityPage = props => {

    const DONT_LOAD_YET = 0;

    const classNames = useClassNames('sb-activity-page');
    const makePageRequest = useMakePageRequest();

    const [events, setEvents] = useState(null);
    const [eventTypes, setEventTypes] = useState([]);
    const [eventTypeFilter, setEventTypeFilter] = useState(null);
    const [lastActivityId, setLastActivityId] = useState(DONT_LOAD_YET);
    const [hasMoreActivity, setHasMoreActivity] = useState(true);

    // const projectId = props.match.params.projId;
    const {contextNodeId} = useSelector(state => state.contextState.context);
    const contextNode = useSelector(selectDeepestBreadcrumb);

    const bottomOfActivityFeed = useRef(null);

    // it looks like this was never used?
    const scrollToBottom = () => {
        bottomOfActivityFeed.scrollIntoView({ behavior: "smooth" });
    }

    const mergeActivities = (existingContextNodeActivities, potentiallyNewContextNodeActivities) => {
        existingContextNodeActivities = existingContextNodeActivities ?? [];

        if (existingContextNodeActivities.length === 0) {
            return potentiallyNewContextNodeActivities;
        }

        const certifiedNewContextNodeActivities = potentiallyNewContextNodeActivities.filter(potentiallyNewContextNodeActivity =>
            existingContextNodeActivities.find(x =>
                x.contextNodeActivityId === potentiallyNewContextNodeActivity.contextNodeActivityId
            ) === undefined
        );

        if(certifiedNewContextNodeActivities.length === 0) {
            setHasMoreActivity(false);
            return existingContextNodeActivities;
        }

        return existingContextNodeActivities.concat(certifiedNewContextNodeActivities);
    };

    useEffect(() => {
        setEvents(null);
        setLastActivityId(DONT_LOAD_YET);
        makePageRequest(
            () => Promise.all([
                ActivityTypeService.Get(contextNodeId),
            ]),
            ([eventTypes]) => {
                setEventTypes(eventTypes.result);
                setHasMoreActivity(true);
                setLastActivityId(null);
            }
        );

    }, [contextNodeId]);

    useEffect(() => {
        if(lastActivityId === DONT_LOAD_YET) { return; }
        makePageRequest(
            () => Promise.all([
                ContextNodeActivityService.Get(contextNodeId, lastActivityId),
            ]),
            ([eventsAjax]) => {
                setEvents(mergeActivities(events, eventsAjax.result));
            }
        );
    }, [lastActivityId]);

    const updateEventTypeFilter = (value) => {
        setEventTypeFilter(ActivityFeedFilterService.CachedValueById(value)?.result);
    };

    const onLoadMore = () => {
        if(!hasMoreActivity) {
            return;
        }
        const lastId = Math.min(...(events.map(x => x.contextNodeActivityId)));
        setLastActivityId(lastId);
    };

    return <Container className={classNames}>
        <Row>
            <Col xs={12} md={12}>
                <h2 className="atomic-sectionheader">
                    {contextNode?.title ?? 'Activity Feed'}
                    <div className="sb-activity-feed-controls float-right">
                        <Row>
                            <Col xs={6}>
                                <ActivityTypeFilter
                                    UpdateValue={updateEventTypeFilter}
                                    Value={eventTypeFilter}
                                    ActivityTypes={eventTypes}
                                />
                            </Col>
                            <Col xs={6}>
                                {
                                    contextNode ?
                                        <ActivityFeedSubscriptionDropDown
                                            ContextNodeId={contextNodeId}
                                        />:
                                        null
                                }
                            </Col>
                        </Row>
                    </div>
                </h2>

                <ActivityFeed
                    Events={events}
                    EventTypes={eventTypes}
                    EventIdLogic={(x) => x.contextNodeActivityId}
                    EventTypeFilter={eventTypeFilter}
                    HasMoreEvents={hasMoreActivity}
                    ClearFilters={() => setEventTypeFilter(null)}
                    OnLoadMore={onLoadMore}
                />
            </Col>
        </Row>
        <div style={{ float:"left", clear: "both" }}
             ref={bottomOfActivityFeed}
        />
    </Container>;
};


